<template>
    <div>
        <div data-title="emptyState" class="row tl-link-block p-4">

            <div class="col-12">
                <p>
                    You are almost ready to start saving and organizing your bookmarks!
                </p>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <div class="card card-choice mb-2 h-100">
                            <div class="card-body">
                                <div v-if="!isMobile()">
                                    <h5 class="card-title mb-1"><i class="bi bi-bookmark-star-fill text-primary mr-2"/>Add the bookmarklet to your browser</h5>
                                    <p class="card-text text-muted mb-4">Drag and drop the button below to your favorites bar to start saving pages.</p>
                                    <Bookmarklet/>
                                </div>
                                <div v-if="isMobile()">
                                    <h5 class="card-title mb-1"><img height="26" src="/share-apple-icon.svg" />Share and save</h5>
                                    <p class="card-text text-muted mb-4">Use your favorite apps' share button to start saving your bookmarks!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <div class="card card-choice mb-2 h-100">
                            <div class="card-body">
                                <div>
                                    <h5 class="card-title mb-1"><i class="bi bi-cloud-arrow-up-fill text-info mr-2"/>Migrate your data</h5>
                                    <p class="card-text text-muted mb-3">Import your existing bookmarks from your browser or pocket account.</p>
                                    <a href="/new-import" class="btn btn-primary btn-lg">Start now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <p class="mt-4 mb-3 text-center">
                <small class="text-muted"><i class="bi bi-question-circle mr-1"/><a :href="helpUrl"> Need help?</a></small>
            </p>
            </div>
        </div>
    </div>
</template>
<script>
import Bookmarklet from "@/components/Bookmarklet";
export default {
    name: "EmptyState",
    components: {
        Bookmarklet
    },
    computed: {
        helpUrl() {
            return this.isMobile() ? "/help#help-ios" : "/help"
        }
    },
    methods: {
        isMobile() {
            return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
        }
    }
}
</script>

<style scoped>

</style>